// AgentProfile.jsx
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function AgentProfile({ agent, onUpdate }) {
  const [form, setForm] = useState({
    companyDescription: agent.companyDescription || '',
    companyImage: agent.companyImage || '',
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const res = await axios.patch('http://localhost:5000/api/agent/update', form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Profile updated successfully!');
      onUpdate(res.data);
    } catch (err) {
      console.error(err);
      toast.error('Update failed.');
    }
  };

  return (
    <div className="bg-white shadow-md rounded-xl p-6 max-w-3xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">Your Profile</h2>

      <div className="flex flex-col sm:flex-row gap-6">
        {/* Left: Profile Info */}
        <div className="flex-1">
          <p><strong>Username:</strong> {agent.username}</p>
          <p><strong>Email:</strong> {agent.email}</p>
          <p><strong>Phone:</strong> {agent.phone}</p>
          <p><strong>Company Name:</strong> {agent.companyName}</p>
          <p><strong>Verified:</strong> {agent.isVerified ? 'Yes' : 'No'}</p>
        </div>

        {/* Right: Company Image */}
        <div className="flex-1 text-center">
          {agent.companyImage ? (
            <img src={agent.companyImage} alt="Company" className="w-48 h-48 object-cover rounded-lg mx-auto" />
          ) : (
            <div className="w-48 h-48 bg-gray-200 rounded-lg flex items-center justify-center mx-auto">
              <span>No Image</span>
            </div>
          )}
        </div>
      </div>

      <form onSubmit={handleSubmit} className="mt-6 space-y-4">
        <textarea
          name="companyDescription"
          value={form.companyDescription}
          onChange={handleChange}
          placeholder="Company Description"
          rows="4"
          className="w-full p-3 border rounded-md"
        />
        <input
          name="companyImage"
          value={form.companyImage}
          onChange={handleChange}
          placeholder="Company Image URL"
          className="w-full p-3 border rounded-md"
        />
        <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition">
          Update Profile
        </button>
      </form>
    </div>
  );
}
